import { createSelector } from 'reselect'

import { selectConfigurationState } from './selectConfigurationState'

export const selectPartnerId = createSelector(
  [selectConfigurationState],
  ({ data }) => data.partnerId
)
